/* eslint-disable max-len */
/* eslint-disable no-console */
import {
  setPageInfo,
  setAdditionalPageInfo,
  setAuthenticationStatus,
  setUserLocalization,
  setSiteInfo,
  setProfileInfo,
  setb2bProfile,
  setProductImpressions
} from './digitalDataBuilder';

import {
  getAnalyticsAuthenticationStatus,
  isLoggedIn,
  getProfileId,
  getb2bProfile,
  isB2BUser,
  getSiteInfo,
} from './thdUserInfo';

import { sendAddToCartEvent } from './addToCartAnalytics';

const setTheHomeDepotCategoryObject = (
  omsId,
  productName,
  brand,
  logEventsToConsole,
  omnitureInfo,
  sendPaymentEstimatorImpressionToAnalytics,
  thdStoreInfo,
  productImpressions,
  pageType,
  pageName
) => {
  if (productImpressions) {
    setProductImpressions(productImpressions);
  }
  const categoryData = omnitureInfo;
  const storeInfo = thdStoreInfo;

  setAdditionalPageInfo('category', categoryData);

  const pageInfoData = {
    pageLoadEvent: 'product view',
    pageName,
    pageType,
  };

  setAdditionalPageInfo('pageInfo', pageInfoData);

  const itemData = {
    productInfo: {
      sku: `${omsId}`,
      name: productName,
      manufacturer: `${brand}`,
      productType: 'merchandise',
      department: '25',
      class: '5',
      subclass: '8',
      availabilityStatus: {
        shipping: {
          sth: 'available',
          boss: 'available',
          skuStatus: 'active',
        },
        store: {
          skuStatus: 'n/a',
        },
        type: 'shared',
        backOrder: 'false',
      },
    },
  };

  setAdditionalPageInfo('item', itemData);

  if (sendPaymentEstimatorImpressionToAnalytics) {
    const paymentEstimatorImpressionData = {
      name: 'buy box',
      feature: 'plcc-est',
      type: 'cta',
    };
    setAdditionalPageInfo('content', paymentEstimatorImpressionData);
  }
  if (storeInfo) {
    setUserLocalization(storeInfo);
  }

  const siteInfo = {
    experienceType: window?.__EXPERIENCE_CONTEXT__.channel,
    betaSite: getSiteInfo() === 'origin' ? 'prod' : 'beta',
    businessType: isB2BUser() ? 'b2b' : 'b2c',
  };

  setSiteInfo(siteInfo);

  if (logEventsToConsole) {
    console.log('window.digitalData', JSON.stringify(window.digitalData));
  }
};

export const customProductPipLoaded = (
  omsId = '325168962',
  productName,
  brand,
  logEventsToConsole,
  omnitureInfo,
  sendPaymentEstimatorImpressionToAnalytics,
  thdStoreInfo,
  productImpressions,
  pageType,
  pageName
) => {
  setTheHomeDepotCategoryObject(
    omsId,
    productName,
    brand,
    logEventsToConsole,
    omnitureInfo,
    sendPaymentEstimatorImpressionToAnalytics,
    thdStoreInfo,
    productImpressions,
    pageType,
    pageName
  );
  setAuthenticationStatus(getAnalyticsAuthenticationStatus());
  if (isLoggedIn()) {
    setProfileInfo(getProfileId());
    setb2bProfile(getb2bProfile());
  }
};

export const addToCartAnalytics = (items, pageType, logEventsToConsole) => {
  if (logEventsToConsole) {
    console.log('addToCartAnalytics items', JSON.stringify(items));
  }
  sendAddToCartEvent(items, pageType);
};

export const groupBy = (arr, groupFn) => arr.reduce(
  (grouped, obj) => ({
    ...grouped,
    [groupFn(obj)]: [...(grouped[groupFn(obj)] || []), obj],
  }),
  {}
);
